import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const CustomerAuthContext = createContext(null);

// Separate axios instance so admin/customer tokens don't collide
const customerAxios = axios.create({ baseURL: API });
customerAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("tas_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { customerAxios };

export function CustomerAuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      const { data } = await customerAxios.get("/customer/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("tas_customer_token")) refresh();
    else setUser(null);
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await customerAxios.post("/customer/login", { email, password });
    localStorage.setItem("tas_customer_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await customerAxios.post("/customer/register", payload);
    localStorage.setItem("tas_customer_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    localStorage.removeItem("tas_customer_token");
    setUser(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ user, login, register, logout, refresh }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
